import { getLiveChatMp4V2Template, getVueLiveChatMp4V2Template } from "../../shortcodes/templates";

const visualizeLiveChatMp4V2 = content => {
  const liveChatShortcode = content.querySelectorAll('[data-wrapper-id="live-chat-mp4-v2-shortcode"]');

  if (liveChatShortcode.length > 0) {
    liveChatShortcode.forEach(item => {
      item.innerHTML = getLiveChatMp4V2Template();
    });
  }
};

const serializeLiveChatMp4V2 = content => {
  const liveChatShortcode = content.querySelectorAll('[data-wrapper-id="live-chat-mp4-v2-shortcode"]');
  if (liveChatShortcode.length > 0) {
    liveChatShortcode.forEach(item => {
      const liveChatData = item.getAttribute("data-live-chat-mp4-data");
      item.innerHTML = getVueLiveChatMp4V2Template(liveChatData);
    });
  }
};

export { visualizeLiveChatMp4V2, serializeLiveChatMp4V2 };
